import { ExamAttendanceActionsList, ExamAttendanceType } from "../actions/examAttendanceActions";
import { Action } from "../actions/types";

const initialValue: Array<ExamAttendanceType> = [];

const examAttendanceReducer = (state: Array<ExamAttendanceType> = initialValue, action: Action) => {
    switch (action.type) {
        case ExamAttendanceActionsList.ADD_EXAM_ATTENDANCE:
            return [
                ...state,
                action.data,
            ];

        case ExamAttendanceActionsList.UPDATE_EXAM_ATTENDANCE:
            const updated = [...state].slice();
            const index = updated.findIndex(u => u.id === action.data.id);

            if (index > -1) {
                updated[index] = {
                    ...action.data,
                };
            }

            return updated;

        case ExamAttendanceActionsList.FETCH_EXAM_ATTENDANCE:
            return action.data;

        case ExamAttendanceActionsList.DELETE_EXAM_ATTENDANCE:
            return state.filter(s => s.id !== action.data);

        default:
            return state;
    }
}

export default examAttendanceReducer;
